// extracted by mini-css-extract-plugin
export default {"sliderContainer":"Slider_sliderContainer__lke9U","dots":"Slider_dots__-Qo1L","side":"Slider_side__0z8Ea","arrow":"Slider_arrow__LZvpW","arrowDisabled":"Slider_arrowDisabled__oNtye"};